import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
	app.config.globalProperties.$q.iconSet.chip.remove = 'fas fa-times-circle'
})
